import { StopTask, StopTaskDTO } from '../domain/stops/StopTask';
import { RouteStopTaskField } from '../domain/stops/StopTaskField';

export class StopTaskMapper {
  static toRepository(task: StopTask): StopTaskDTO {
    return {
      id: task.id,
      stop_id: task.stop_id,
      label: task.label,
      status: task.status,
      fields: task.fields
        .filter((field) => field.value !== null)
        .map((field) => ({
          id: field.id,
          label: field.label,
          type: field.type,
          value: field.value as string | string[],
          is_custom_field: field.is_custom_field,
        })),

      // CRUD
      created_at: task.created_at,
    };
  }

  static toDomain(task: StopTaskDTO): StopTask {
    return StopTask.create(
      {
        stop_id: task.stop_id,
        label: task.label,
        status: task.status,
        fields: task.fields.map((field) =>
          RouteStopTaskField.create({
            id: field.id,
            label: field.label,
            type: field.type,
            value: field.value,
            is_custom_field: field.is_custom_field,
          })
        ),
        created_at: task.created_at,
      },
      task.id
    );
  }
}
